import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Button } from 'ui-components/components/button';

import { emptyArray } from 'ui-components/default-props/empty';
import { useScreenSizeContext } from '../../../contexts/screen-size-resolution';
import { CompleteCheck } from './complete-check';
import style from './style.module.less';

const OnboardingStep = ({
  stepTitle,
  description,
  connectedList = null,
  buttonTitle,
  addAnotherMessage = null,
  shouldHideMainButton = true,
  onClick,
  isComplete = false,
  shouldDisplayCompleteCheck = true,
  secondaryActions = emptyArray,
  isMarketplaceStep = false,
  messageBelowTitle = null,
}) => {
  const { isMobile } = useScreenSizeContext();
  const isMainButtonHidden = isComplete && shouldHideMainButton;
  const renderConnectedList = () => {
    if (isComplete) {
      return connectedList;
    }
    return <div className={style['step-description']}>{description}</div>;
  };
  const renderActionSection = () => {
    if (isMainButtonHidden) {
      return (
        <>
          {!isMobile && shouldDisplayCompleteCheck && <CompleteCheck />}
          {addAnotherMessage && (
            <Button className={style['add-another-button']} onClick={onClick} theme='link'>
              {addAnotherMessage}
            </Button>
          )}
          {!messageBelowTitle && secondaryActions}
        </>
      );
    }
    return (
      <>
        <Button className={style['add-button']} onClick={onClick} theme='primary'>
          {buttonTitle}
        </Button>
        {secondaryActions}
      </>
    );
  };

  if (isMarketplaceStep && isComplete) {
    return (
      <div className={classNames(style['step-container'], style['is-marketplace'])}>
        <div className={style['step-header']}>
          <div className={style['step-text-title-wrapper']}>
            <div className={style['step-title-and-message-below']}>
              <h3>{stepTitle}</h3>
              {messageBelowTitle}
            </div>
            {isMainButtonHidden && isMobile && shouldDisplayCompleteCheck && <CompleteCheck />}
          </div>
          <div className={style['step-action-container']}>{renderActionSection()}</div>
        </div>
        {renderConnectedList()}
      </div>
    );
  }

  return (
    <div className={style['step-container']}>
      <div className={style['step-text-container']}>
        <div className={style['step-text-title-wrapper']}>
          <h3>{stepTitle}</h3>
          {isMainButtonHidden && isMobile && shouldDisplayCompleteCheck && <CompleteCheck />}
        </div>
        {renderConnectedList()}
      </div>
      <div className={style['step-row-container']}>
        <div className={style['step-action-container']}>{renderActionSection()}</div>
      </div>
    </div>
  );
};

export default OnboardingStep;

OnboardingStep.propTypes = {
  stepTitle: PropTypes.node.isRequired,
  description: PropTypes.node.isRequired,
  buttonTitle: PropTypes.node.isRequired,
  addAnotherMessage: PropTypes.node,
  shouldHideMainButton: PropTypes.bool,
  shouldDisplayCompleteCheck: PropTypes.bool,
  connectedList: PropTypes.node,
  onClick: PropTypes.func.isRequired,
  isComplete: PropTypes.bool,
  secondaryActions: PropTypes.arrayOf(PropTypes.node),
  isMarketplaceStep: PropTypes.bool,
  messageBelowTitle: PropTypes.node,
};
